import { map } from 'lodash';
import { Location } from './location';

export class Permission {
    permissionId: number;
    permissionName: string;

    constructor(data: any) {
        this.permissionId = data?.permissionId;
        this.permissionName = data?.permissionName;
    }

}